import { RestApiGetDocument } from "@pathwright/graphql-client/src/generated"

export default RestApiGetDocument
